import { configureStore } from "@reduxjs/toolkit";
import modeReducer from "./slices/mode";
import subjectReducer from "./slices/subject";
import galleryReducer from "./slices/gallery";
import autoCaptureOptionsReducer from "./slices/autoCaptureOptions";
import sdkOptionsReducer from "./slices/sdkOptions";
import showSpinnerReducer from "./slices/showSpinner";
import documentTypeReducer from "./slices/documentType";
import currentlyCapturingReducer from "./slices/currentlyCapturing";
import countryReducer from "./slices/country";
import errorReducer from "./slices/error";
import retakeReducer from "./slices/retake";
import manualOnlyReducer from "./slices/manualOnly";
import guidReducer from "./slices/guid";
import scanUserReducer from "./slices/scanUser";
import tokenReducer from "./slices/token";
import submittedReducer from "./slices/submitted";

export default configureStore({
  reducer: {
    guid: guidReducer,
    scanUser: scanUserReducer,
    token: tokenReducer,
    country: countryReducer,
    mode: modeReducer,
    subject: subjectReducer,
    gallery: galleryReducer,
    autoCaptureOptions: autoCaptureOptionsReducer,
    sdkOptions: sdkOptionsReducer,
    showSpinner: showSpinnerReducer,
    documentType: documentTypeReducer,
    currentlyCapturing: currentlyCapturingReducer,
    error: errorReducer,
    retake: retakeReducer,
    manualOnly: manualOnlyReducer,
    submitted: submittedReducer,
  },
});
